import { Button } from '@/components/ui/button';
import { useGetVideo } from '@/features/videos/api/get-video/get-video.hook';

/** Resolve the selected version through the ownership-checked video endpoint. */
export function SourceVideoPreview({ videoId }: { videoId: string }) {
  const { video, isLoading, refetch } = useGetVideo(videoId);
  const source = video?.id === videoId ? video : null;
  if (isLoading) return <p role="status">Loading video…</p>;
  if (!source?.blobUrl) {
    return (
      <div className="mb-2 text-sm">
        <p>Video preview unavailable.</p>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => {
            void refetch();
          }}
        >
          Retry
        </Button>
      </div>
    );
  }
  return (
    // biome-ignore lint/a11y/useMediaCaption: generated source uses burned-in captions; no separate caption track exists
    <video
      aria-label="Video to edit"
      className="mb-2 max-h-72 max-w-full rounded-lg"
      src={source.blobUrl}
      poster={source.thumbnailUrl ?? undefined}
      controls
      playsInline
      preload="metadata"
    />
  );
}
